import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

const useAxios = () => {
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  axiosInstance.interceptors.request.use(async (req) => {
    try {
      const session = await fetchAuthSession(); // auto-refreshes if needed
      const token = session.tokens?.idToken?.toString();
      if (!token) {
        throw new Error("No ID token in session");
      }
      req.headers.Authorization = `Bearer ${token}`;
    } catch (err) {
      console.error("Failed to attach token (session expired?):", err?.name ?? err);
      window.location.href = "/login?reason=session_expired";
    }

    return req;
  });

  return axiosInstance;
};

export default useAxios;
